import Icon from '../../../images/icons/name.svg';
import { TagAttribute } from '../../lib/tag';
import { RegisterWidget, Widget } from '../../lib/widget';
import type { TagDefinition } from "../../lib/tag";
import template from './tagunits.html';
import { UnitsMap } from '../../lib/tagunits';

@RegisterWidget({tag: 'tag-units', displayName: 'Tag Units', icon: Icon, section: 'Tag Information', template: template})
export class TagUnits extends Widget {
    unitsElement: HTMLElement;
    @TagAttribute({displayName: 'Units Tag'}) unitsTag: TagDefinition;

    protected connectedCallback(): void {
        this.unitsElement = this.shadowRoot?.getElementById('units')!;
    }

    protected enliven(): void {
        this.unitsElement.innerHTML = UnitsMap.get(this.unitsTag.tag.units)?.abbrev ?? '';
    }
}